/**
 * External dependencies
 */
import React, { useState } from "react";
import { connect } from "react-redux";
import { Box, Text, Stack } from "@towersystems/towersystems-design-system";
import Dropdown from "react-dropdown";
import { map, get, compact, first, findIndex } from "lodash";

/**
 * Internal dependencies
 */
import { SidebarOverlay } from "modules/report-builder/layout";
import Button from "components/button";
import { getCubeMeasures, getCubeDimensions } from "state/graph-cube/selectors";
import { getBuilderReportId } from "state/ui/report-builder/selectors";
import { getEditedReport } from "state/reports/selectors";
import { FILTERS } from "./constants";
import { editReport } from "state/reports/actions";

const FiltersOverlay = ({
  goBack,
  reportId,
  report,
  filter,
  members,
  onSubmit,
  ...props
}) => {
  const [value, setValue] = useState(filter || {});
  const isDisabled =
    !value || !value.member || !value.operator || !value.values;

  //console.log(!value, !value.member, !value.operator, !value.values);

  const handleSubmit = () => {
    // need to find out what filter was updated based on the member

    let filters = get(report, "config.filters", []);
    let index = findIndex(filters, { member: filter.member });

    if (index < 0) {
      filters = [...filters, value];
    } else {
      filters[index] = value;
    }

    props.editReport(reportId, { config: { filters: filters } });
    onSubmit && onSubmit({ config: { filters: filters } });
    goBack();
  };

  return (
    <SidebarOverlay goBack={goBack}>
      <Box padding="large">
        <Stack space="large">
          <Box>
            <Text>Filter</Text>
            <Dropdown
              value={value.member}
              options={members}
              onChange={(v) => {
                setValue({ ...value, member: v.value });
              }}
            />
          </Box>
          <Box>
            <Text>Operator</Text>
            <Dropdown
              value={value.operator}
              options={FILTERS}
              onChange={(v) => {
                setValue({ ...value, operator: v.value });
              }}
            />
          </Box>
          <Box>
            <Text>Value</Text>
            <input
              value={first(value.values)}
              type="text"
              onChange={(e) => {
                setValue({ ...value, values: [e.target.value] });
              }}
            />
          </Box>
          <Box>
            <Button disabled={isDisabled} onClick={handleSubmit}>
              Continue
            </Button>
          </Box>
        </Stack>
      </Box>
    </SidebarOverlay>
  );
};

export default connect(
  (state) => {
    let reportId = getBuilderReportId(state);
    let report = getEditedReport(state, reportId);

    let selectableMeasures = getCubeMeasures(
      state,
      report && report.config.dataSet
    );
    let selectableDimensions = getCubeDimensions(
      state,
      report && report.config.dataSet
    );

    return {
      reportId,
      report,
      members: compact(
        map(
          [...selectableDimensions, ...selectableMeasures],
          ({ shortTitle, name }) => {
            return (
              name && {
                value: name,
                label: name,
              }
            );
          }
        )
      ),
    };
  },
  {
    editReport,
  }
)(FiltersOverlay);
